<template>
  <div>
    <v-container fluid>
      <v-row>
        <v-card-text class="pa-0">
          <v-row>
            <v-col cols="4">
              <v-autocomplete
                hide-details="auto"
                :items="warehouses"
                :loading="loadingShops"
                v-model="selectedwarehouse"
                @input="getAllWarehouses(search)"
                item-text="name"
                item-value="id"
                label="Warehouse"
                outlined
                dense
                @change="emitInput"
                :search-input.sync="searchWH"
              ></v-autocomplete>
            </v-col>
            <v-col cols="4"></v-col>
            <v-col cols="3">
              <SearchAutoComplete
                v-model="search"
                :clear="clearFilter"
              ></SearchAutoComplete>
            </v-col>
            <v-col cols="1">
              <TableHeaderFilter :columns="columns" />
            </v-col>
          </v-row>

          <v-card-title class="d-flex justify-space-between"
            >Product Details
            <v-btn
              hidden
              small
              class="text-white btn_gray w-100 d-none d-sm-flex"
              v-print="printQr"
              >Print <v-icon right dark> mdi-printer </v-icon></v-btn
            ></v-card-title
          >
          <StockProductsTemplate
            id="warehouseproducts"
            :datas="data"
            :warehousedata="productDetails"
            style="display: none"
            class="test1"
            :columns="columns"
            :isWarehouse="true"
          />
          <v-simple-table fixed-header dense>
            <template v-slot:default>
              <div
                v-if="productDetails.length == 0"
                class="mt-16 container justify-center item-center"
              >
                <img
                  style="height: 200px"
                  src="../../assets/img/no-result.jpg"
                />
              </div>
              <thead v-if="productDetails.length > 0">
                <tr>
                  <th
                    class="text-left"
                    v-if="col.show"
                    v-for="(col, index) in columns"
                  >
                    {{ col.text }}
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(item, index) in productDetails" :key="item.name">
                  <td v-if="columns[0].show">{{ index + 1 }}</td>
                  <td v-if="columns[1].show">{{ item.name }}</td>
                  <td v-if="columns[2].show">{{ item.brand }}</td>
                  <td v-if="columns[3].show">{{ item.category }}</td>
                  <td v-if="columns[4].show">
                    {{ item.unit }}
                  </td>
                  <td v-if="columns[5].show">{{ item.batch }}</td>
                  <td v-if="columns[6].show">{{ item.selling_price }}</td>
                  <!-- <td v-if="columns[7].show">{{ item.damage }}</td> -->
                  <td v-if="columns[7].show">{{ item.available_stock }}</td>

                  <v-col sm="3" class="global_search d-none d-md-flex">
                    <v-menu
                      transition="slide-y-transition"
                      bottom
                      :nudge-width="50"
                      content-class="my-menu"
                      :close-on-content-click="false"
                    >
                      <template v-slot:activator="{ on, attrs }">
                        <v-ship>
                          <v-icon color="orange darken-2" dark small v-on="on">
                            mdi-cash-check
                          </v-icon>
                        </v-ship>
                      </template>
                      <v-list>
                        <v-list-item>
                          <v-row>
                            <v-col cols="12">
                              <v-ship small>
                                {{ item.purchase_price }}
                              </v-ship>
                            </v-col>
                          </v-row>
                        </v-list-item>
                      </v-list>
                    </v-menu>
                  </v-col>
                </tr>
              </tbody>
            </template>
          </v-simple-table>
        </v-card-text>
      </v-row>
    </v-container>

    <!-- Pagination Begin -->
    <Pagination
      @paginationOptions="setPaginationOptions"
      @response="setResponseData"
      @getPageNumber="setPagenumber"
      :url="WarehouseProductsURL"
      :filterAction="true"
      :filter="filterData"
      ref="pagination"
    />
    <!-- Pagination End -->

    <div class="d-flex justify-center align-center"></div>
    <!-- </v-row> -->
  </div>
</template>

<script>
// Components
import PageTitle from '@/components/shared/PageTitle';
import TableFilters from '@/components/base/TableFilters';
import StockProductsTemplate from '@/components/PrintTemplates/StockProductsTemplate';
import Pagination from '../shared/components/pagination.vue';
import SearchAutoComplete from '@/components/base/SearchAutoComplete.vue';

export default {
  data: () => ({
    warehouses: [],
    products: [],
    data: {
      warehouse: null,
      type: 'Warehouse',
    },
    search: null,
    searchwarehouse: null,
    selectedwarehouse: null,
    productDetails: [],
    loadingShops: false,
    searchWH: null,
    columns: [
      {
        text: 'No',
        show: true,
      },
      {
        text: 'Name',
        show: true,
        disabled: true,
      },
      {
        text: 'Brand',
        show: true,
      },
      {
        text: 'Category',
        show: true,
      },
      {
        text: 'Unit',
        show: true,
        disabled: true,
      },
      {
        text: 'Batch',
        show: true,
        disabled: true,
      },

      {
        text: 'Selling Price',
        show: true,
        align: 'right',
      },
      // {
      //   text: "Damage",
      //   show: true,
      //   align: "center",
      // },
      {
        text: 'Available Stock',
        show: true,
        align: 'center',
      },
    ],
  }),
  components: {
    PageTitle,
    TableFilters,
    StockProductsTemplate,
    Pagination,
    SearchAutoComplete,
  },

  methods: {
    // async getAllProducts(value) {
    //   this.data.warehouse=this.warehouses.find(p=>p.id==this.selectedwarehouse)
    //   await this.$store
    //       .dispatch("report/GetWarehouseProducts", {
    //         query: value,
    //         warehouseId: this.selectedwarehouse,
    //       })
    //       .then((res) => {

    //         this.products = res.data.data;

    //         this.productDetails = this.products;
    //       })
    //       .catch((err) => {});
    // },
    async getAllWarehouses(value) {
      await this.$store
        .dispatch('warehouse/GetWarehouses', {})
        .then((res) => {
          this.warehouses = res;
          // this.selectedwarehouse = 1;
          this.data.warehouse = this.warehouses.find(
            (p) => p.id == this.selectedwarehouse,
          );
        })
        .catch((err) => {});
    },
    getWarehouseByQuery(query = '') {
      this.loadingShops = true;
      this.$store
        .dispatch('warehouse/GetWarehouses', {
          query: query,
          status: 'active',
        })
        .then((res) => {
          this.warehouses = res;
          this.loadingShops = false;
        })
        .catch((err) => {
          this.loadingShops = false;
        });
    },

    emitInput() {
      this.$emit('input', this.selectedwarehouse);
    },
    // Pagination
    setPagenumber(event) {
      this.$router.push('?page=' + event);
      this.$store.dispatch('SetProductSize', event);
    },
    refreshData() {
      this.$refs.pagination.refreshData();
    },
    setResponseData(data) {
      this.products = data;

      this.productDetails = this.products;
    },
  },

  created() {
    this.getAllWarehouses('');
  },
  computed: {
    printQr() {
      return {
        id: 'warehouseproducts',
        popTitle: 'Product Details',
      };
    },
    filterData: function () {
      return {
        warehouse: this.selectedwarehouse,
        search: this.search,
      };
    },
    WarehouseProductsURL: function () {
      return `dashboard/warehouses/${this.selectedwarehouse}/products`;
      // return `products/shops/${this.selectedShop}`;
    },
  },
  watch: {
    searchwarehouse: {
      handler(val) {
        this.getAllProducts(val);
      },
      deep: true,
    },
    searchWH: {
      handler(val) {
        this.getWarehouseByQuery(val);
      },
      deep: true,
    },
  },
};
</script>
